/**
 * Utility functions for formatting switchboard data
 */

/**
 * Formats a Date object to MM/DD/YYYY HH:MM AM/PM format
 * @param date - The date to format
 * @returns Formatted date string in MM/DD/YYYY HH:MM AM/PM format
 */
export function formatSwitchboardTimestamp(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const year = date.getFullYear()

  let hours = date.getHours()
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'

  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  const hoursStr = String(hours).padStart(2, '0')

  return `${month}/${day}/${year} ${hoursStr}:${minutes} ${ampm}`
}
